import React from 'react'

export default function HeaderSearch() {
    return (
        <div className="search-wrap">
            <div className="input-wrap">
                <input type="text" className='form-control' placeholder='Search' />
            </div>
            <button className='btn-wrap'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.1076 12.1027C13.2795 10.9255 14.004 9.30168 14.004 7.50847C14.004 3.91394 11.0929 1 7.50198 1C3.91104 1 1 3.91394 1 7.50847C1 11.103 3.91104 14.0169 7.50198 14.0169C9.30151 14.0169 10.9303 13.2852 12.1076 12.1027ZM12.1076 12.1027L17 17" stroke="#777777" />
                </svg>

            </button>
        </div>
    )
}
